module.exports = __webpack_public_path__ + "static/media/Kaya_2026_Logo.9598e292.png";